export var TransitionTime;
(function (TransitionTime) {
    TransitionTime["HALF"] = "0.11s";
    TransitionTime["BASE"] = "0.22s";
    TransitionTime["DOUBLE"] = "0.44s";
})(TransitionTime || (TransitionTime = {}));
export var TransitionTimeValue;
(function (TransitionTimeValue) {
    TransitionTimeValue[TransitionTimeValue["HALF"] = 110] = "HALF";
    TransitionTimeValue[TransitionTimeValue["BASE"] = 220] = "BASE";
    TransitionTimeValue[TransitionTimeValue["DOUBLE"] = 440] = "DOUBLE";
})(TransitionTimeValue || (TransitionTimeValue = {}));
export const Transition = {
    Time: TransitionTime,
    TimeValue: TransitionTimeValue,
};
//# sourceMappingURL=transition.js.map